import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Inicio from '../pages/Inicio';
import Termos from '../pages/Termos';
import Privacidade from '../pages/Privacidade';
import Listas from '../pages/Listas';
import Lost404 from '../pages/Lost404';
import Lista from '../pages/Lista';

class Routes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Inicio} />
          <Route path="/lista/:id" component={Lista} />
          <Route path="/listas/:id" component={Listas} />
          <Route path="/termos" exact component={Termos} />
          <Route path="/privacidade" exact component={Privacidade} />
          <Route path="*" component={Lost404} />
        </Switch>
      </BrowserRouter>
    )
  }
}

export default (Routes)